export default function closeSectionMenu(e){
  // Remove the menu from the screen
  $('.rwnav-section-side-menu').remove();

  // Remove the overflow:hidden style from the body so scrolling is possible
  $('body').removeClass('hide-overflow');

  // Remove the class on the site wrapper container that signals that side nav is currently open
  $('.site-wrapper').removeClass('rwnav-section-side-is-open');

}
